export default __webpack_public_path__ + "static/media/manual-de-utilizacao-inss.0f862d59.pdf";